import { Button, Paper, Stack, Typography } from "@mui/material";

export default function ReflectionVideosSection({
  videos,
  loading,
  onAdd,
  renderVideoSkeletons,
  renderUnifiedList,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: "1px solid #d9ead3",
        background: "#edf7e7",
        mb: 3,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography variant="h6">Reflection videos</Typography>
        <Button variant="contained" onClick={onAdd}>
          Add Video
        </Button>
      </Stack>
      {loading ? (
        renderVideoSkeletons(3)
      ) : videos.length === 0 ? (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            border: "1px dashed #cbd5e1",
            background: "#fff",
            borderRadius: 2,
            color: "#607d8b",
            textAlign: "center",
          }}
        >
          No reflection videos uploaded yet.
        </Paper>
      ) : (
        renderUnifiedList(videos, "video")
      )}
    </Paper>
  );
}
